import { Action } from 'redux/action';
import { UsersActions } from 'redux/reducers/usersReducer';

export const userScreenUpdate = (data: any): Action<UsersActions, any> => ({
  type: UsersActions.userScreenUpdated,
  data,
});
